import { AddIcon } from "@chakra-ui/icons";
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Table,
  Tbody,
  Td,
  Tfoot,
  Th,
  Thead,
  Tr,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import {
  getAddCourseData,
  setCourses,
  setDescription,
  setTitle,
} from "redux/slices/AddCourseSlice";
import { getAddRessourceData } from "redux/slices/addRessourceSlice";
import AddCourse from "./AddCourse";
interface CoursesModalProps {
  formationsId: number;
  setFormationId: React.Dispatch<React.SetStateAction<number>>;
}
const CoursesModal: React.FC<CoursesModalProps> = ({
  formationsId,
  setFormationId,
}: CoursesModalProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [id, setId] = useState(0);
  const [resId, setResId] = useState(0);
  const dispatch = useAppDispatch();
  const fileUrl = useAppSelector(getAddRessourceData).fileUrl;
  const { title, description, courses, ressource, ressourceType } =
    useAppSelector(getAddCourseData);
  const addCourseHandler = (e: React.FormEvent) => {
    e.preventDefault();

    console.log({ title, description });
    dispatch(
      setCourses([
        ...courses,
        {
          id: id,
          image: "",
          title,
          ressourceType: ressourceType,
          ressource: ressource,
          description,
          addedOn: new Date(),
          lastModifiedOn: new Date(),
          formationId: formationsId,
        },
      ])
    );
    console.log(courses);
    setId(id + 1);
    setResId(resId + 1);
    dispatch(setTitle(""));
    dispatch(setDescription(""));
  };
  return (
    <>
      <Button leftIcon={<AddIcon />} colorScheme={"brand"} onClick={onOpen}>
        Cours
      </Button>

      <Modal
        closeOnOverlayClick={false}
        isOpen={isOpen}
        size={"4xl"}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Liste des cours</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Table variant="striped" colorScheme="brand">
              <Thead>
                <Tr>
                  <Th>Nom du cours</Th>
                  <Th>description</Th>
                  <Th isNumeric>Id formation</Th>
                  <Th>Ajouté Le</Th>
                  <Th>Modifié Le</Th>
                </Tr>
              </Thead>
              <Tbody>
                {courses &&
                  courses.map((item, i) => (
                    <Tr key={i}>
                      <Td>{item.title}</Td>
                      <Td>{item.description}</Td>
                      <Td isNumeric>{item.formationId}</Td>
                      <Td>{new Date(item.addedOn).toDateString()}</Td>
                      <Td>{new Date(item.lastModifiedOn).toDateString()}</Td>
                    </Tr>
                  ))}
              </Tbody>
              <Tfoot>
                <Tr>
                  <Th>Nom du cours</Th>
                  <Th>description</Th>
                  <Th isNumeric>Id formation</Th>
                  <Th>Ajouté Le</Th>
                  <Th>Modifié Le</Th>
                </Tr>
              </Tfoot>
            </Table>

            <AddCourse id={id} submitHandler={addCourseHandler} />
            <VStack></VStack>
          </ModalBody>

          <ModalFooter>
            <Button onClick={onClose} colorScheme="brand" mr={3}>
              Enregistrer
            </Button>
            <Button onClick={onClose}>Annuler</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
export default CoursesModal;
